import React, { Fragment, useCallback, useEffect, useState } from "react";
import { Grid, IconButton, Skeleton } from "@mui/material";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import GirlIcon from '@mui/icons-material/Girl';
import BoyIcon from '@mui/icons-material/Boy';
import { PieChart, ColumnChart } from '../../../components/charts';
import { InfluencerProfileService } from '../../../core/services/influencer-profile.service';
import { ListService, LocalService, UserService } from '../../../core/services';
import { DefaultUserProfile } from '../../../config/config';
import { ResponseType } from "custom-type";
import { connect } from "react-redux";
import { Loading, UserLogin } from "../../../redux/action";
import { HandlesService } from "../../../core/services/handles.service";
import InstagramIcon from "../../../components/icons/instagram-icon";
import { CreateCampaign as CampaignService } from "../../../core/services";
import { FormValidation, Methods } from "../../../core/utility";
import { Link, NavLink } from 'react-router-dom';
import InsightMediaDetailCard from './post-card';
import InsightMediaReelsCard from './reels-card';
import InsightMediaCarouselCard from './carousel-card';
import InsightMediaImageCard from './image-card';
import CityList from './city-list';
import { LineChartDropDown } from "../../../components/charts/line-chart";
import InfluencerProfileLeft from "./influencer-profile-left";
import FollowerCard from "./follower-card";
import FollowerCardInline from "./follower-card-inline";
import FollowerSection from "./followers/follower-sec";
import FollowerSecInline from "./followers/follower-sec-inline";
import PostFrequency from "./followers/post-frequency";
import Audience from "./audience/audience";
import Engagement from "./engagement/engagement";
import InstagramIcon1 from "../../../components/icons/instagram-icon1";
import InsightMediaLatestPostCard from "./latest-post"
import useBodyClass from "../../../hooks/useBodyClass";
import * as gtUtil from "../../../core/utility";
import { toast } from "react-toastify";
import SocialConnectRestriction from '../../../components/popup/social-connect-restrict';
import ContentLoading from "../../../components/loader/loading";
import Tooltip from "@mui/material/Tooltip";
import dayjs from "dayjs";
import moment from "moment";
import { AdvancedColumnChart } from "../../../components/charts/advanced-column-chart";
import ChatBotWidget from "./ChatBotWidget";
import { MapInfluencerForAIFrontend } from "./MapInfluencerForAIFrontend";
import CommonPopUp from "../../../components/popup/common-popup";
import MaterialSymbol from "../../../components/icons/material-symbol";
import { WhatsappIcon, WhatsappShareButton } from "react-share";
// Brands' Send message / Add to list: the new flow's chat and lists (never the old inbox, lists or campaigns).
const CreatorQuickActions = React.lazy(() => import("../../../modules/brand/components/insight/CreatorQuickActions"));

const inflProfileService: InfluencerProfileService = new InfluencerProfileService()
const handlesService = new HandlesService();
const methods = new Methods();

interface Props {
  UserReducer: any;
  loading: (data: any) => void;
  getSubscriptionDetail: any;
  updateUser: any;
}


const quarterlyMap: Record<
  string,
  { values: number[]; lastDate: string; lastTimestamp: number }
> = {};

// const buildQuarterlyData = (data: any[], valueKey: string) => {
//   const quarterlyMap: any = {};

//   data.forEach((item) => {
//     if (!item?.updated_at) return;

//     const date = moment(item.updated_at);
//     const year = date.year();
//     const quarter = Math.floor(date.month() / 3) + 1;
//     const key = `${year}-Q${quarter}`;

//     if (!quarterlyMap[key]) {
//       quarterlyMap[key] = {
//         metricSum: 0,
//         postsSum: 0,
//         lastDate: date,
//       };
//     }

//     const metricValue = Number(item[valueKey]) || 0;
//     const postsValue = Number(item.total_posts_availaible) || 0;

//     quarterlyMap[key].metricSum += metricValue;
//     quarterlyMap[key].postsSum += postsValue;

//     if (date.isAfter(quarterlyMap[key].lastDate)) {
//       quarterlyMap[key].lastDate = date;
//     }
//   });

//   return Object.values(quarterlyMap).map((q: any) => ({
//     name: q.lastDate.format("DD MMM YY"),
//     y: q.metricSum,          // Main chart value
//     totalPosts: q.postsSum,  // Tooltip extra value
//   }));
// };


const buildQuarterlyData = (
  data: any[],
  valueKey: string,
  isAverage: boolean = false
) => {
  const quarterlyMap: any = {};

  data.forEach((item) => {
    if (!item?.updated_at) return;

    const date = moment(item.updated_at);
    const year = date.year();
    const quarter = Math.floor(date.month() / 3) + 1;
    const key = `${year}-Q${quarter}`;

    if (!quarterlyMap[key]) {
      quarterlyMap[key] = {
        metricSum: 0,
        count: 0,
        postsSum: 0,
        lastDate: date,
      };
    }

    const metricValue = Number(item[valueKey]) || 0;
    const postsValue = Number(item.total_posts_availaible) || 0;

    quarterlyMap[key].metricSum += metricValue;
    quarterlyMap[key].postsSum += postsValue;
    quarterlyMap[key].count += 1;

    if (date.isAfter(quarterlyMap[key].lastDate)) {
      quarterlyMap[key].lastDate = date;
    }
  });

  return Object.entries(quarterlyMap).map(([key, q]: any) => {
  const year = q.lastDate.year();
  const quarter = Math.floor(q.lastDate.month() / 3);

  const startMonth = moment().quarter(quarter + 1).startOf('quarter');
  const endMonth = moment().quarter(quarter + 1).endOf('quarter');

  const label = `${startMonth.format("MMM")}–${endMonth.format("MMM")} ${String(year).slice(-2)}`;

  return {
    name: label, // ✅ Quarter label
    y: isAverage
      ? Number((q.metricSum / q.count).toFixed(0))
      : q.metricSum,
    totalPosts: q.postsSum,
    isAverage,
  };
});
};




const listService: ListService = new ListService()
const userService = new UserService();
const localService = new LocalService();

const ProfileInsight: React.FC<Props> = (props: Props) => {
  const [influencerId] = useState(() => {
    const idString = new URLSearchParams(window.location.href).get('influencerId');
    return idString ? parseInt(idString, 10) : 0;
  });
  const [audienceHealthAccess, setAudienceHealthAccess] = useState(false);
  const [isAudienceHealthState, setIsAudienceHealthState] = React.useState('False');
  const [selectInflu, setSelectInflu] = useState<any>([]);
  const [influencerData, setInfluencerData] = useState<any>([]);
  const [genderSplitPieChartData, setGenderSplitPieChartData] = useState<any[]>([]);
  const [loading, setIsLoading] = useState(false)
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const [columnChartData, setColumnChartData] = useState<any[]>([]);
  const [genderArrayLabel, setGenderArrayLabel] = useState()
  const [postErComparisonData, setPostErComparisonData] = useState<any[]>([]);
  const [influencerList, setInfluencerList] = useState<any>(null);
  const [value, setValue] = useState("1");
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [location, setLocation] = useState('');
  const [categories, setCategories] = useState([]);
  const [language, setLanguages] = useState([]);
  const [subscription_status, setSubscription_status] = useState<any>({
    status: null,
    plan_start_date: null,
    plan_end_date: null
  });
  const [connected_profile, set_connected_profile] = useState<Boolean>(false);
  const [connect, setConnect] = useState<Boolean>(false);
  const [fb_connected, setFb_connected] = useState<Boolean>(false);
  const [error_msg_mismatch, set_error_message_mismatch] = useState<Boolean>(false);
  const [query, setQuery] = useState("");
  const [AIresponse, setAIResponse] = useState(null);
  const [onRequestUpdate, setOnRequestUpdate] = useState<boolean>(false);
  const [requestingUpdate, setRequestingUpdate] = useState<boolean>(false);
  
  const utCapitals:any = {
    "Andaman and Nicobar Islands": "Port Blair",
    "Chandigarh": "Chandigarh",
    "Dadra and Nagar Haveli and Daman and Diu": "Daman",
    "Delhi": "New Delhi",
    "Jammu and Kashmir": "Srinagar (Summer), Jammu (Winter)",
    "Ladakh": "Leh",
    "Lakshadweep": "Kavaratti",
    "Puducherry": "Puducherry"
  };
  // to get connected instagram account sm_id
  async function getConnectedAccountId(influencer_id: number | string) {
    try {
      const res: any = await handlesService.getConnectedAccountsIgFb(influencer_id, props.UserReducer.account_type);
      if (res?.data?.rows.length > 0) {
        if(res.data.rows[0].token_status === 'Connected') {
          setFb_connected(true);
        }
        const connectedAccountData = res.data.rows.filter(
          (filter: any) => (filter.account_type === 'Primary' || filter.ig_account_type === 'Primary') || (props.UserReducer.account_type === 'Talent Partner' && (filter.account_type === 'Secondary' || filter.ig_account_type === 'Secondary'))
        );
        if (connectedAccountData.length > 0) {
          return connectedAccountData[0].ig_id;
        }
      }

    } catch (err: any) {
      console.error('Error fetching connected accounts:', err);
      // Handle the error as needed...
    }

    // Return a default value or handle the case when no connected account is found
    return null;
  }

  useEffect(() => {
    const fetchData = async () => {
      let idToSet;
      try {
        if (urlParams.get("sm_id") == null) {
          idToSet = await getConnectedAccountId(props?.UserReducer?.influencer_id);
        } else {
          idToSet = urlParams.get("sm_id");
        }
      } catch (error) {
        console.error('Error setting Instagram ID:', error);
      }

      // Continue with other logic after setting Instagram ID
      getProfileInsight(idToSet);
    };

    fetchData();
  }, [connect]);

  useEffect(() => {

  }, [props.getSubscriptionDetail])
  const [dataInitialized, setDataInitialized] = useState(false);
  //3rd chart
  const getProfileInsight = async (instagramID: any) => {
    setIsLoading(true)
    setDataInitialized(false);
    try {

      let response;

      if (props?.UserReducer?.account_type === 'Brand' || props?.UserReducer?.account_type === 'Agency') {
        response = await inflProfileService.getBrandProfile({
          sm_id: instagramID,
          user_id: props.UserReducer.user_id,
          account_id: props.UserReducer.account_id,
          brand_id: props.UserReducer.brand_id,
          influencer_id: props?.UserReducer?.account_type === 'Influencer' || props?.UserReducer?.account_type === 'Talent Partner'
            ? props?.UserReducer?.influencer_id
            : urlParams.get('influencerId') || 0
        });
      } else {
        response = await inflProfileService.getInfluencerProfile({
          sm_id: instagramID,
          user_id: props.UserReducer.user_id,
          account_id: props.UserReducer.account_id,
          brand_id: props.UserReducer.brand_id,
          influencer_id: props?.UserReducer?.account_type === 'Influencer' || props?.UserReducer?.account_type === 'Talent Partner'
            ? props?.UserReducer?.influencer_id
            : urlParams.get('influencerId') || 0
        });
      }

      if (response.status === gtUtil.Constants.SUCCESS) {
        set_connected_profile(false);
        setInfluencerData(response?.data?.rows);
        setOnRequestUpdate(response?.data?.rows?.profile_detail?.[0]?.on_request_update === true || response?.data?.rows?.profile_detail?.[0]?.on_request_update === 'True');
        setSelectInflu(response?.data?.rows?.profile_detail);
        setIsAudienceHealthState(response?.data?.rows?.profile_detail[0]?.audience_health);
        setAudienceHealthAccess(props?.UserReducer?.ig_audience_health === 'True');
        const data = response?.data?.rows?.location_category_language[0];
        if (!data) {
          return;
        }
        else{
        let locationString = "";

        if (data?.state && utCapitals[data.state]) {
          if (data.state === "Delhi") {
            // Special case for Delhi: Show "New Delhi, Delhi, India"
            locationString = `New Delhi, ${data.state}, ${data?.country ? data.country : ""}`;
          } else {
            // For other Union Territories
            locationString = ` ${utCapitals[data.state]}, ${data?.city ? data.city : ""}, ${data?.country ? data.country : ""}`;
          }
        } else {
          locationString = `${data?.city ? data.city : ""}, ${data?.state ? data.state : ""}, ${data?.country ? data.country : ""}`;
        }
        setLocation(locationString);
       
        // Extract categories and filter out null values
        const categoryList: any = [
          data?.category1,
          data?.category2,
          data?.category3,
          data?.category4
        ].filter(category => category !== null);
        setCategories(categoryList);
        const languageList: any = [
          data?.lang1,
          data?.lang2,
          data?.lang3,
          data?.lang4
        ].filter(language => language !== null);
        setLanguages(languageList);
      
        }
          
        const genderSplitData = response?.data?.rows?.detail;

        //Gender Split Data
      if (!Array.isArray(genderSplitData) || genderSplitData.length === 0) {
        console.error("genderSplitData is not a valid array:", genderSplitData);
        return;
      }
      

          if (Array.isArray(genderSplitData) && genderSplitData.length > 0) {
            const maleArray = genderSplitData[0]?.total_male_count || 0;
            const femaleArray = genderSplitData[0]?.total_female_count || 0;


            const genderPieChartData = [
              { name: "Male", y: maleArray, color: "#497FD6" },
              { name: "Female", y: femaleArray, color: "#DD5A5D" },
            ];

            setGenderSplitPieChartData(genderPieChartData);
          } else {
            console.error("genderSplitData is invalid or empty:", genderSplitData);
            // Optional: Display a toast or error message here
          }
        setIsLoading(false);
        setPhone(response?.data?.rows?.email_phone[0]?.primary_phone)
        setEmail(response?.data?.rows?.email_phone[0]?.primary_email)
        setSubscription_status(response?.data?.rows?.subscription_status);
        
        const ageGenderData = response?.data?.rows?.age_gender;
        if (Array.isArray(ageGenderData)) {
          // let fGenderArray: any = ageGenderData?.filter((item) => item.age_gender_range.includes("F."));
          // let mGenderArray: any = ageGenderData?.filter((item) => item.age_gender_range.includes("M."));
          let mGenderArray = ageGenderData
            .filter((item) => (item.age_gender_range.startsWith("M_") || item.age_gender_range.startsWith("M.")))
            .map((item) => item.value);

          let fGenderArray = ageGenderData
            .filter((item) => (item.age_gender_range.startsWith("F_") || item.age_gender_range.startsWith("F.")))
            .map((item) => item.value);

          let genderArrayLabelSet = new Set(ageGenderData.map(item => item.age_gender_range.replace(/[FMU_, F.M.U.]/g, '')));
          let genderLabel: any = [...genderArrayLabelSet];
          genderLabel.sort();
          setGenderArrayLabel(genderLabel);
          const newColumnChartData = [
            {
              name: "Male",
              data: mGenderArray,
              color: '#497FD6'
            },
            {
              name: "Female",
              data: fGenderArray,
              color: '#DD5A5D'

            },
          ];

          setColumnChartData(newColumnChartData);

        } else {
          // localService.toastify(response.data.status.message, "info", 1000);
        }
        
        //Post Est Reach Comparison Data

        const erComparisonData = response?.data?.rows?.detail;
        if (Array.isArray(erComparisonData)) {
          let imageArray = ((erComparisonData[0]?.image_posts_est_reach_comparison + erComparisonData[0]?.carousel_posts_est_reach_comparison) / 2) || 0;
          let reelArray = erComparisonData[0].reels_posts_est_reach_comparison || 0;
          // let carouselArray = erComparisonData[0]?.carousel_posts_est_reach_comparison ? erComparisonData[0]?.carousel_posts_est_reach_comparison : 0;
          const postErData = [

            {
              name: "Images",
              type: "column",
              groupPadding: 0.8,
              data: [{
                name: 'image',
                value: imageArray
              }],
              color: "#0A7447",
            },
            {
              name: "Reels",
              type: "column",
              groupPadding: 0.8,
              data: [{
                name: 'reel',
                value: reelArray
              }],
              color: "#34E098",
            },
            // {
            //   name: "Carousel",
            //   type: "column",
            //   groupPadding: 0.8,
            //   data: [{
            //     name: 'carousel',
            //     value: carouselArray
            //   }],
            //   color: "#5da8b0",
            // },
          ];

          setPostErComparisonData(postErData);
        } else {
          // localService.toastify(response.data.status.message, "info", 1000);
        }
      }else{
        if(response.status === gtUtil.Constants.DB_QUERY_NO_RECORD_FOUND){
          set_connected_profile(true);
        }
      }
    } catch (error) {
      console.log(`inflProfileService error :: ${JSON.stringify(error)}`);
    } finally {
      setIsLoading(false);
      setDataInitialized(true); 
    }
  }

  useEffect(() => {
    _InfluencerList();

  }, [props.UserReducer.brand_id, props.UserReducer.user_id]);



  function _InfluencerList() {
    CampaignService.influencerList({
      user_id: props.UserReducer.user_id,
      brand_id: props.UserReducer.brand_id,
    }).then((res: any) => {
      if (res.data.status === 1) {
        setInfluencerList(res.data.rows);
      } else {
        setInfluencerList(null);
      }
    });
  }

  //Male and female and Adult count
  const totalMaleCount = influencerData?.detail?.[0]?.total_male_count ?? 0;
  const totalFemaleCount = influencerData?.detail?.[0]?.total_female_count ?? 0;
  const totalAdultCount = influencerData?.detail?.[0]?.total_adult_count ?? 0;


  useBodyClass("page-profile-insight")

  // -------------------- SHARE PROFILE (public link) --------------------
  // Mirrors the campaign analytics share flow (detailed-analytics.tsx). The
  // backend returns a self-contained JWT link, so no db changes are required.
  const [openSharePopup, setOpenSharePopup] = useState(false);
  const [shareURL, setShareURL] = useState("");
  const [shareLoading, setShareLoading] = useState(false);

  // sm_id + influencer_id of the profile currently being viewed.
  const shareSmId = influencerData?.profile_detail?.[0]?.ig_id;
  const shareInfluencerId = influencerData?.profile_detail?.[0]?.influencer_id;

  // Fetches the public share URL on demand and caches it in state.
  const fetchShareURL = async (): Promise<string> => {
    if (shareURL) return shareURL;
    if (!shareSmId || !shareInfluencerId) {
      localService.toastify("Profile is still loading, please try again.", "info", 1000);
      return "";
    }
    try {
      setShareLoading(true);
      const res = await inflProfileService.profileInsightSharePublicLink({
        sm_id: shareSmId,
        influencer_id: shareInfluencerId,
      });
      if (res?.data?.status) {
        const url = res?.data?.url || "";
        setShareURL(url);
        return url;
      }
      console.error("Error fetching share URL:", res?.data?.message);
      return "";
    } catch (error) {
      console.error("Error while fetching profile share URL:", error);
      return "";
    } finally {
      setShareLoading(false);
    }
  };

  const handleOpenSharePopup = async () => {
    setOpenSharePopup(true);
    await fetchShareURL();
  };

  const handleCloseSharePopup = () => {
    setOpenSharePopup(false);
  };

  const handleCopyShareLink = async () => {
    const url = await fetchShareURL();
    if (url) {
      navigator.clipboard.writeText(url);
      localService.toastify("Link Copied", "success", 1000);
    }
  };

  const [showRefreshPopup, setShowRefreshPopup] = useState<boolean>(false);
  const [refreshPopupMessage, setRefreshPopupMessage] = useState<string>("");

  const handleCloseRefreshPopup = () => {
    setShowRefreshPopup(false);
  };

  const handleUpdateProfileRequest = async () => {
    if (requestingUpdate) return;
    if (onRequestUpdate) {
      setRefreshPopupMessage("Your request is already in the queue. Please check back later.");
      setShowRefreshPopup(true);
      return;
    }
    setRequestingUpdate(true);
    try {
      const response: any = await inflProfileService.requestProfileUpdate({
        sm_id: influencerData?.profile_detail?.[0]?.ig_id,
        platform: selectInflu?.[0]?.platform_type,
        user_id: props.UserReducer.user_id,
        account_id: props.UserReducer.account_id,
        brand_id: props.UserReducer.brand_id,
        influencer_id: props?.UserReducer?.account_type === 'Influencer' || props?.UserReducer?.account_type === 'Talent Partner'
          ? props?.UserReducer?.influencer_id
          : urlParams.get('influencerId') || 0
      });
      if (response.status === gtUtil.Constants.SUCCESS) {
        setOnRequestUpdate(true);
        setRefreshPopupMessage("Your request has been processed. Please visit your profile again later.");
        setShowRefreshPopup(true);
      } else {
        localService.toastify(response?.message || "Unable to request profile update", "error", 1000);
      }
    } catch (error) {
      console.error('Error requesting profile update:', error);
      localService.toastify("Unable to request profile update", "error", 1000);
    } finally {
      setRequestingUpdate(false);
    }
  };

  const [social_loader, set_social_loader] = useState<boolean>(false);
    const [loadingInstagram, setLoadingInstagram] = React.useState(false);
    
        const [instagramAccount, setInstagramAccount] = React.useState<any>([]);
           const [ig_data, set_ig_data] = useState({});
            const [yt_data, set_yt_data] = useState({});
               const [socialRestrictionPopup, set_socialRestrictionPopup] = useState({
                    youtube: false,
                    instagram: false
                })
  async function getInstagramAccounts() {
    try{
    setLoadingInstagram(true)
    handlesService
        .getConnectedInstagramAccounts(
            props?.UserReducer?.influencer_id
        )
        .then((res: any) => {
            if (res?.data?.rows.length > 0) {
                setInstagramAccount(res?.data?.rows);
            }
        })
        .catch((err: any) => {
            console.log(err)
            setLoadingInstagram(false)
        })}catch(err){
            console.log(err)
            setLoadingInstagram(false)
        }finally{
            setLoadingInstagram(false)
        }
}
        const instagramConnect = async () => {
          try {
            const response = await handlesService.instagramConnect();
        
            if (response.status === gtUtil.Constants.SUCCESS) {
              const popup = window.open(
                response.data.url,
                "InstagramOAuthPopup",
                "width=500,height=600,left=100,top=100"
              );
        
              if (!popup) {
                toast.error("Popup blocked. Please allow popups and try again.");
                return;
              }
        
              const channel = new BroadcastChannel('oauth-channel');
              channel.onmessage = async (event) => {
                if (event.data?.type === 'social-auth-success') {
                  const authCode = event.data.code;
                  channel.close();
        
                  try {
                    set_social_loader(true);
        
                    const response = await handlesService.postInstagramConnect({
                      code: authCode,
                      influencer_id: props.UserReducer.influencer_id,
                    });
        
                    if (response.status === gtUtil.Constants.SUCCESS) {
                      updateUserReducer();
                      getInstagramAccounts();
                      setConnect(!connect);
                    } else if (response.info === 'Social account already connected to the other account.') {
                      set_ig_data(response.data);
                      set_socialRestrictionPopup(prev => ({
                        ...prev,
                        instagram: true,
                      }));
                    }
                  } catch (err) {
                    console.error("Error posting Instagram auth code:", err);
                    toast.error("Instagram authentication failed.");
                  } finally {
                    set_social_loader(false);
                  }
                }
              };
            } else {
              console.error("Error fetching Instagram OAuth URL:", response.info);
              toast.error("Failed to get Instagram authentication URL.");
            }
          } catch (error) {
            console.error("Instagram Connect Error:", error);
            toast.error("Instagram login failed");
          } finally {
            set_social_loader(false);
          }
        };
        async function updateUserReducer() {
          let latestUserReducerData = await userService.getUpdatedUserReducer(props.UserReducer);
          if (![undefined, null, ''].includes(latestUserReducerData)) {
              props.updateUser(latestUserReducerData)
          }
      }

            const handleCloseSocialPopup_IG = async (id: any) => {
              set_socialRestrictionPopup(prevState => ({
                  ...prevState,
                  instagram: false 
              }));
          
              try {
                  const response = await handlesService.continueConnect({
                      ig_id: id,
                      influencer_id: props?.UserReducer?.influencer_id,
                      continues: false,
                  });
          
                  if (response.status === gtUtil.Constants.SUCCESS) {
                      updateUserReducer();
                      setConnect(!connect);
                  } else {
                      console.log('Error occurred');
                  }
              } catch (error) {
                  console.error('API Error:', error);
              }finally{
                  set_social_loader(false);
              }
            };

                const handleContinueConnect_IG = async (id: any) => {
                  set_socialRestrictionPopup(prevState => ({
                      ...prevState,
                      instagram: false 
                  }));
              
                  try {
                      const response = await handlesService.continueConnect({
                          ig_id: id,
                          influencer_id: props?.UserReducer?.influencer_id,
                          continues: true,
                      });
              
                      if (response.status === gtUtil.Constants.SUCCESS) {
                          updateUserReducer();
                          setConnect(!connect);
                      } else {
                          console.log('Error occurred');
                      }
                  } catch (error) {
                      console.error('API Error:', error);
                  }finally{
                      set_social_loader(false);
                  }
                };

              const fb_instagramConnect = async () => {
                try {
                  // if (!username_verify) {
                  //   console.error("Username is required for Facebook authentication.");
                  //   toast.error("Username is required.");
                  //   return;
                  // }
              
                  const response = await handlesService.fb_instagramConnect();
              
                  if (response.status === gtUtil.Constants.SUCCESS) {
                    // Open Facebook OAuth in a popup window
                    const popup = window.open(
                      response.data.url,
                      "FacebookOAuthPopup",
                      "width=500,height=600,left=100,top=100"
                    );
              
                    if (!popup) {
                      toast.error("Popup blocked. Please allow popups and try again.");
                      return;
                    }
              
                    const channel = new BroadcastChannel('oauth-channel');
                    channel.onmessage = async (event) => {
                      if (event.data?.type === 'social-auth-success') {
                        const authCode = event.data.code;
                        channel.close();
              
                        try {
                          set_social_loader(true);
              
                          // Send auth code to backend
                          const tokenResponse = await handlesService.postFacebookConnect({
                            code: authCode,
                            influencer_id: props?.UserReducer?.influencer_id,
                            username: influencerData?.profile_detail?.[0]?.username,
                          });
              
                          if (tokenResponse.status === gtUtil.Constants.SUCCESS) {
                            updateUserReducer();
                            set_social_loader(false);
                            setConnect(!connect);
                          } else {
                            if (tokenResponse.info === 'Social account already connected to the other account.') {
                              set_ig_data(tokenResponse.data);
                              set_socialRestrictionPopup(prevState => ({
                                ...prevState,
                                instagram: true
                              }));
                            }

                            if(tokenResponse.info === 'Social media account does not match.'){
                              set_error_message_mismatch(true);
                            }else{
                              set_error_message_mismatch(false);
                            }
                          }
                        } catch (error) {
                          console.error("Error processing Facebook auth response:", error);
                          toast.error("Facebook authentication failed.");
                        } finally {
                          set_social_loader(false);
                        }
                      }
                    };
                  } else {
                    console.error("Error fetching Facebook OAuth URL:", response.info);
                    toast.error("Failed to get Facebook authentication URL.");
                  }
                } catch (error) {
                  console.error("Facebook Login Error:", error);
                  toast.error("Facebook Connect failed.");
                } finally {
                  set_social_loader(false);
                }
              };
  const followers = influencerData?.advanced_graph?.map((i: any) => i.followers);
  const mediaCount = influencerData?.advanced_graph?.map((i: any) => i.media_count);
  // const avgComments = influencerData?.advanced_graph?.map((i: any) => i.public_avg_comments);
  // const avgLikes = influencerData?.advanced_graph?.map((i: any) => i.public_avg_likes);
const quarterlyAvgLikesData = buildQuarterlyData(
  influencerData?.advanced_graph || [],
  "public_avg_likes" // ✅ average mode
);

const quarterlyAvgCommentsData = buildQuarterlyData(
  influencerData?.advanced_graph || [],
  "public_avg_comments"   // ✅ average mode
);

const quarterlyTotalLikesData = buildQuarterlyData(
  influencerData?.advanced_graph || [],
  "total_like_public_profile"
  // default = sum
);

const quarterlyTotalCommentsData = buildQuarterlyData(
  influencerData?.advanced_graph || [],
  "total_comments_public_profile"
  // default = sum
);

//   console.log("DATA LENGTH:", avgLikes.length);
// console.log("DATA:", avgLikes);
  // const totalLikes = influencerData?.advanced_graph?.map((i: any) => i.total_like_public_profile);
  // const totalPosts = influencerData?.advanced_graph?.map((i: any) => i.total_posts_availaible);
  const totalComments = influencerData?.advanced_graph?.map((i: any) => i.total_comments_public_profile);
const dates = influencerData?.advanced_graph?.map((i: any) => {
  return new Date(i.updated_at).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "2-digit",
  });  
});
let datesLabel: any = dates;
const followersDataSource = [
  {
    name: "Followers",  
    data: followers?.map((y: any, index: number) => ({
      name: datesLabel[index],
      y
    })) || [],  
  }
];

const MediaCountDataSource = [
  {
    name: "Total Posts",

    data: mediaCount?.map((y: any, index: number) => ({
      name: moment(dates[index]).format("DD MMM YY"),   // ✅ use date label here
      y,
      rangeName:moment(dates[index]).format("DD MMM YY"), 
    })),  
  }
];
const avgCommentsDataSource = [
  {
    name: "Avg. Comments",
    data: quarterlyAvgCommentsData,
  }
];
// Group monthly data into quarters



const avgLikesDataSource = [
  {
    name: "Avg. Likes",
    data: quarterlyAvgLikesData,
  }
];

const totalLikesDataSource = [
  {
    name: "Likes",
    data: quarterlyTotalLikesData
  }
];

const totalCommentsDataSource = [
  {
    name: "Comments",

    data: quarterlyTotalCommentsData
  }
];
const [AILoading, setAILoading] = useState(false)
const [messages, setMessages] = useState<
  { role: "user" | "ai"; text: string }[]
>([]);

const sendMessage = useCallback(async (text: string) => {
  if (!text.trim()) return;

  setMessages(prev => [...prev, { role: "user", text }]);
  setAILoading(true);

  try {
    const lightweightAIData = MapInfluencerForAIFrontend(influencerData);
    const res = await inflProfileService.getIGProfileAIData({
      influencerData: lightweightAIData,
      user_query: text,
      user_id: props.UserReducer.user_id,
      brand_id: props.UserReducer.brand_id,
      account_id: props.UserReducer.account_id,
    });
    setMessages(prev => [
      ...prev,
      { role: "ai", text: res?.data?.answer ?? "Unable to analyze.", isNew: true }
    ]);
  } finally {
    setAILoading(false);
  }
}, [
  selectInflu,
  props.UserReducer.user_id,
  props.UserReducer.brand_id,
  props.UserReducer.account_id
]);
const handleAudienceHealthClick = async () => {
  if (isAudienceHealthState === 'Completed') {
    toast.info("Audience Quality is already active.");
    return;
  }
  if(audienceHealthAccess){
    const response = await inflProfileService.activeAudienceHealth({
      influencer_id: props?.UserReducer?.influencer_id,
      sm_id: influencerData?.profile_detail?.[0]?.ig_id
    });
    if (response.status === gtUtil.Constants.SUCCESS) {
      setIsAudienceHealthState('True');
      toast.success(response.data.message);
    } else {
      toast.error(response.data.message);
    }    
  } else {
    toast.error("You do not have access to Audience Quality insights.");
  }
};
  return (
    <Fragment>
      {!dataInitialized ? <ContentLoading width="125" height="125" />  :
      ((props?.UserReducer?.account_type === 'Influencer' || props?.UserReducer?.account_type === 'Talent Partner') && connected_profile) ? (
        <div style={{ textAlign: "center" }}>
        Please <span style={{borderBottom:'1px solid #2b2b2b', cursor:'pointer', fontWeight:'bold'}} onClick={instagramConnect}>verify</span> your Instagram account to retrieve the profile.
      </div>
      ) : (
            <div className="container">
              <div className="influencer-profile">
                {/* <div className="common-tab mb-0 d-lg-none common-tab-mobile">
                  <span className="active common-tab-menu">Instagram</span>
                  <span className="common-tab-menu d-none">YouTube</span>
                </div> */}
                <div className="influencer-profile__left">
                  <InfluencerProfileLeft accountType={props?.UserReducer?.account_type} onRequestUpdate={onRequestUpdate} handleUpdateProfileRequest={handleUpdateProfileRequest} requestingUpdate={requestingUpdate} influencerData={influencerData} email={email} phone={phone} location={location} language={language} category={categories} loading={loading} subscription_status={subscription_status} />
                </div>
                <div className="influencer-profile__right">
                  <div className="d-flex flex-wrap w-100 align-items-center mb-3">
                    {/* <div className="common-tab mb-0 d-none d-lg-inline-flex">
                      <span className="active common-tab-menu">{influencerData?.profile_detail?.[0]?.username && <InstagramIcon1 width="20px" height="20px" />}{influencerData?.profile_detail?.[0]?.username}</span>
                      {/* <span className="common-tab-menu">YouTube</span>
                    </div> */}
                    <div className="d-none d-lg-flex align-items-center">
                      {influencerData?.profile_detail?.[0]?.username && <InstagramIcon1 width="20px" height="20px" className="mb-1" />}
                      <Link target="_blank" className="btn btn-text-link" to={`https://www.instagram.com/${influencerData?.profile_detail?.[0]?.username}`}>
                        <span>{influencerData?.profile_detail?.[0]?.username}</span>
                      </Link>
                      {/* <Tooltip
                        title={`Profile updated at ${new Date(selectInflu[0].updated_at).toLocaleString('en-IN', {
                          day: '2-digit',
                          month: 'short',
                          year: 'numeric',
                        })}`}
                        arrow
                      >
                        <span className="ms-2 text-muted" style={{ fontSize: '13px' }}>
                          {new Date(selectInflu[0].updated_at).toLocaleDateString('en-IN', {
                            day: '2-digit',
                            month: 'short',
                            year: 'numeric',
                          })}
                        </span>
                      </Tooltip> */}
                    </div>
                    <div className="d-flex d-lg-none align-items-center mt-1 mb-2 gap-2">
                    <span className='profile-updated'>{`Last updated on
                      ${dayjs(influencerData.updated_at).format("MMM D, YYYY")}`}
                    </span>
                    
                    {(props.UserReducer.account_type === 'Influencer' || props.UserReducer.account_type === 'Talent Partner' || props.UserReducer.account_type === 'Brand' || props.UserReducer.account_type === 'Agency') && (
                      <div className="d-flex align-items-center" >
                        <span
                          className={`d-inline-flex fs-12 fw-600 align-items-center ${requestingUpdate ? 'disabled pe-none opacity-50' : 'cursor-pointer'}`}
                          onClick={requestingUpdate ? undefined : handleUpdateProfileRequest}
                        >
                          {onRequestUpdate ? 'Refresh' : 'Refresh'}

                        </span>
                          <Tooltip arrow title="Refresh your profile to get the latest insights.">
                          <IconButton className='p-0'>
                              <MaterialSymbol className="me-0" iconName="info" fontweight="200" fontSize="16px" />
                          </IconButton>
                        </Tooltip>
                    </div>
                    )}
                    {/* {influencerData?.profile_detail?.[0]?.platform_type === 'Instagram' &&
                    <div className="d-flex align-items-center" >
                      <span
                        className={`d-inline-flex align-items-center fs-12 fw-600 ${(onRequestUpdate || requestingUpdate) ? 'disabled pe-none opacity-50' : 'cursor-pointer'}`}
                        onClick={(onRequestUpdate || requestingUpdate) ? undefined : handleUpdateProfileRequest}
                      >
                        
                        {onRequestUpdate ? 'Refresh' : 'Refresh'}
                        
                      </span>
                      <Tooltip arrow title="Refresh your profile to get the latest insights.">
                      <IconButton className='p-0'>
                          <MaterialSymbol className="me-0" iconName="info" fontweight="200" fontSize="16px" />
                      </IconButton>
                    </Tooltip>
                    </div>
                    } */}
                    </div>
                    {(props.UserReducer.account_type === 'Brand' || props.UserReducer.account_type === 'Agency') && (
                      <div className='infl-profile-detail-action ms-auto'>
                        <React.Suspense fallback={null}>
                          <CreatorQuickActions
                            platform="instagram"
                            buttonClassName="btn btn-text-link me-2"
                            creator={{
                              influencerId: Number(selectInflu?.[0]?.influencer_id) || 0,
                              smId: Number(selectInflu?.[0]?.ig_id) || 0,
                              platform: 'Instagram',
                              accountId: Number(selectInflu?.[0]?.account_id) || 0,
                              userId: Number(selectInflu?.[0]?.user_id) || 0,
                              name: String(selectInflu?.[0]?.insta_name || selectInflu?.[0]?.username || ''),
                              username: String(selectInflu?.[0]?.username || ''),
                              image: selectInflu?.[0]?.gcp_profile_image_url || selectInflu?.[0]?.profile_image_url || null,
                            }}
                          />
                        </React.Suspense>
                        {/* {influencerData?.profile_detail?.[0]?.platform_type === 'Instagram' &&
                        <>
                          <span
                            className={`btn btn-text-link btn-sm px-0 d-inline-flex align-items-center me-2 ${(onRequestUpdate || requestingUpdate) ? 'disabled pe-none opacity-50' : 'cursor-pointer'}`}
                            onClick={(onRequestUpdate || requestingUpdate) ? undefined : handleUpdateProfileRequest}
                          >
                            <MaterialSymbol className="me-1" iconName="refresh" fontweight="200" fontSize="18px" />
                            {onRequestUpdate ? 'Refresh requested' : 'Refresh Profile'}
                            
                          </span>
                          <Tooltip arrow title="Refresh your profile to get the latest insights.">
                          <IconButton className='p-0'>
                              <MaterialSymbol className="ms-1 me-1" iconName="info" fontweight="200" fontSize="18px" />
                          </IconButton>
                        </Tooltip>
                        </>
                        } */}
                        <span
                          className="cursor-pointer btn btn-primary d-inline-flex align-items-center"
                          onClick={handleOpenSharePopup}
                        >
                          <MaterialSymbol className="me-1" iconName="share" fontweight="200" fontSize="18px" />
                          Share
                        </span>
                      </div>
                    )}
                    {/* {(props.UserReducer.account_type === 'Influencer' || props.UserReducer.account_type === 'Talent Partner') && influencerData?.profile_detail?.[0]?.platform_type === 'Instagram' && (
                      <div className='infl-profile-detail-action ms-auto'>
                         
                        <span
                          className={`btn btn-outline-primary btn-sm d-inline-flex align-items-center ${(onRequestUpdate || requestingUpdate) ? 'disabled pe-none opacity-50' : 'cursor-pointer'}`}
                          onClick={(onRequestUpdate || requestingUpdate) ? undefined : handleUpdateProfileRequest}
                        >
                          <MaterialSymbol className="me-1" iconName="refresh" fontweight="200" fontSize="18px" />
                          {onRequestUpdate ? 'Refresh Requested' : 'Refresh Profile'}
                          
                        </span>
                        <Tooltip arrow title="Refresh your profile to get the latest insights.">
                          <IconButton className='p-0'>
                              <MaterialSymbol className="ms-1" iconName="info" fontweight="200" fontSize="18px" />
                          </IconButton>
                        </Tooltip>
                       
                      </div>
                    )} */}
                  </div>
                  {/* {loading ? <Skeleton height={24} /> :
                    <div className="d-none d-lg-flex gap-1"><InstagramIcon1 width="20px" height="20px" /><Link
                      className="influencer-profile__social-chan d-none d-lg-flex"
                      to={`https://www.instagram.com/${influencerData && influencerData?.profile_detail?.[0]?.username}`}
                      target="_blank"
                    >
                      <span className="influ-prof-info-social-username d-flex justify-content-center align-items-baseline">
                        {loading ? <Skeleton height={30} /> : <>@{influencerData?.profile_detail?.[0]?.username}</>}
                      </span>
                    </Link>
                    </div>
                  } */}
                  <div className="followers-info d-none d-md-flex flex-column">
                    
                    {/* FOLLOWERS SECTION */}
                    <FollowerSection loading={loading} influencerData={influencerData} />
                    {/* FOLLOWERS SECTION ENDS */}
                  
                  
                    {/* FOLLOWERS SECTION INLINE */}
                    <FollowerSecInline loading={loading} influencerData={influencerData} />
                    {/* FOLLOWERS SECTION INLINE ENDS */}
                    {/* POST FREQUENCY SECTION  */}
                    <PostFrequency loading={loading} influencerData={influencerData} />
                  </div>
                  {/* POSTS DATA MOBILE  */}
                    <div className="d-md-none w-100">
                      {/* FOLLOWERS SECTION */}
                        <FollowerSection influencerData={influencerData} loading={loading} />
      {/* FOLLOWERS SECTION INLINE */}

                      <strong className="influencer-profile__common__title audience pb-2 d-block">Posts Data</strong>
                    <FollowerSecInline influencerData={influencerData} loading={loading} />
                    {/* FOLLOWERS SECTION INLINE ENDS */}
                      {/* FOLLOWERS SECTION ENDS */}
                    </div>
                  {/* POST FREQUENCY SECTION ENDS  */}
                  {/* Audience */}
                {/* {(props?.UserReducer?.ig_audience_health === 'True' && influencerData?.audience_health?.length == 0) && (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      marginBottom: '.5rem',
                      width: '100%',
                    }}
                  >
                    <button
                      className="btn btn-primary active-audience-btn"
                      onClick={handleAudienceHealthClick}
                      disabled={isAudienceHealthLoading}
                    >
                      {isAudienceHealthLoading ? 'Analyzing Audience Quality…' : 'Check Audience Quality'}
                    </button>
                  </div>
                )} */}


                  {(loading || influencerData?.age_gender?.length > 0 || genderSplitPieChartData[0]?.y > 0 || genderSplitPieChartData[1]?.y > 0 || influencerData?.city_country?.length > 0 || influencerData?.city_indian?.length > 0 || influencerData?.city_international?.length > 0) &&
                    <Audience isAudienceHealthAccess = {audienceHealthAccess} isAudienceHealthState={isAudienceHealthState} handleAudienceHealthClick={handleAudienceHealthClick} genderSplitPieChartData={genderSplitPieChartData} influencerData={influencerData} columnChartData={columnChartData} genderArrayLabel={genderArrayLabel} loading={loading} handleChange={handleChange} value={value} />
                  } 

                  {(!fb_connected && (props?.UserReducer?.account_type === 'Influencer' || props?.UserReducer?.account_type === 'Talent Partner')) && <span style={{fontSize:"11px"}}>If the data seems inaccurate to you, please 
                                        <button
                                            className="mx-1 btn btn-text-link"
                                            onClick={fb_instagramConnect}
                                            style={{fontSize: '11px'}}
                                        >
                                            connect
                                        </button> 
                    your profile to ensure we fetch the most updated insights.</span>}
                  {error_msg_mismatch && <span className="error">Social media account does not match.</span>}
                  {/* {loading ? <Skeleton height={24} /> :
                    <div className="d-none d-lg-flex gap-1"><InstagramIcon1 width="20px" height="20px" /><Link
                      className="influencer-profile__social-chan d-none d-lg-flex"
                      to={`https://www.instagram.com/${influencerData && influencerData?.profile_detail?.[0]?.username}`}
                      target="_blank"
                    >
                      <span className="influ-prof-info-social-username d-flex justify-content-center align-items-baseline">
                        {loading ? <Skeleton height={30} /> : <>@{influencerData?.profile_detail?.[0]?.username}</>}
                      </span>
                    </Link>
                    </div>
                  } */}
                 
                  {/* ENGAGEMENT */}
                  {(loading || influencerData?.profile_data?.[0]?.reels_total_reach || influencerData?.profile_data?.[0]?.image_total_reach || influencerData?.profile_data?.[0]?.carousel_avg_impressions || postErComparisonData[0]?.data[0]?.value > 0 || postErComparisonData[1]?.data[0]?.value > 0) &&
                    <Engagement influencerData={influencerData} loading={loading} postErComparisonData={postErComparisonData} />
                  }
                  <strong className="influencer-profile__common__title audience position-relative">Advanced Insights</strong>
                  <Grid container spacing={{ xs: 0, sm: 3 }} className="mb-3">
                    <>{followersDataSource?.[0]?.data?.length > 0 && (
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}

                      className="influencer-profile__common__inner"
                    >
                      
                      <div className="influencer-profile__common__box">
                        <div className="inner-heading">Followers</div>
                        <LineChartDropDown
                          dataSource={followersDataSource}
                          categories={datesLabel}
                          exporting={false}
                          legend={false}
                          chartType="line"
                          height="240px"
                          lineWidth={2}
                          
                          
                          
                        />
                      </div>

                    </Grid>

                    )}</>
                     {MediaCountDataSource?.[0]?.data?.length > 0 && (
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}

                      className="influencer-profile__common__inner"
                    >
                      <div className="influencer-profile__common__box">
                        <div className="inner-heading">Total Posts</div>
                         <LineChartDropDown
                          dataSource={MediaCountDataSource}
                          categories={datesLabel}
                          exporting={false}
                          legend={false}
                          chartType="line"
                          height="240px"
                          lineWidth={2}
                        />
                      </div>
                    </Grid>
                     )}
                     {avgLikesDataSource?.[0]?.data?.length > 0 && (
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}

                      className="influencer-profile__common__inner"
                    >
                      <div className="influencer-profile__common__box">
                        <div className="inner-heading">Average Likes</div>
                        <AdvancedColumnChart
                          id="average-like"
                          dataSource={avgLikesDataSource}
                          barWidth={10}
                          height="300px"
                          legend={false}
                        />
                      </div>
                    </Grid>
                     )}
                     {avgCommentsDataSource?.[0]?.data?.length > 0 && (
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}

                      className="influencer-profile__common__inner"
                    >
                      <div className="influencer-profile__common__box">
                        <div className="inner-heading">Average Comments</div>
                        <AdvancedColumnChart
                          id="average-comment"
                          dataSource={avgCommentsDataSource}
                          barWidth={10}
                          height="300px"
                          legend={false}
                        />
                      </div>
                    </Grid>
                     )}
                     {totalLikesDataSource?.[0]?.data?.length > 0 && (
                    
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}

                      className="influencer-profile__common__inner"
                    >
                      <div className="influencer-profile__common__box">
                        <div className="inner-heading">Likes</div>
                        <AdvancedColumnChart
                          id="total-like"
                          dataSource={totalLikesDataSource}
                          barWidth={10}
                          height="300px"
                          legend={false}
                        />
                      </div>
                    </Grid>
                     )}
                     {totalCommentsDataSource?.[0]?.data?.length > 0 && (
                     
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}

                      className="influencer-profile__common__inner"
                    >
                      <div className="influencer-profile__common__box">
                        <div className="inner-heading">Comments</div>
                        <AdvancedColumnChart
                          id="total-comments"
                          dataSource={totalCommentsDataSource}
                          barWidth={10}
                          height="300px"
                          legend={false}
                        />
                      </div>
                    </Grid>
                     )}
                    
                  </Grid>
                  {(influencerData?.top_stories?.length !== 0 || influencerData?.most_viewed_reels?.length !== 0 || influencerData?.most_liked_images?.length !== 0) &&
                    <strong className="influencer-profile__common__title pb-1">Posts</strong>
                  }
                  {/* MOST VIEWED STORIES STARTS*/}
                  {(loading || influencerData?.top_stories?.length > 0) &&
                    <section className='sec-media-posts'>
                      <div className='container custom-container'>
                        <strong className='sec-media-posts__title'>Stories</strong>
                        <InsightMediaDetailCard influencerData={influencerData && influencerData} loading={loading} />
                      </div>
                    </section>
                  }
                  {/* MOST VIEWED STORIES ENDS */}
                  {/* LATEST POSTS STARTS */}
                  {(loading || influencerData?.latest_posts?.length > 0) &&
                    <section className='sec-media-posts'>
                      <div className='container custom-container'>
                        <strong className='sec-media-posts__title'>Latest Posts</strong>
                        <InsightMediaLatestPostCard influencerData={influencerData} loading={loading} />
                      </div>
                    </section>
                  }
                  {/* LATEST POSTS ENDS */}
                  {/* MOST VIEWED REELS STARTS */}
                  {(loading || influencerData?.most_viewed_reels?.length > 0) &&
                    <section className='sec-media-posts'>
                      <div className='container custom-container'>
                        <strong className='sec-media-posts__title'>Most Liked Reels</strong>
                        <InsightMediaReelsCard influencerData={influencerData} loading={loading} />
                      </div>
                    </section>
                  }
                  {/* MOST VIEWED REELS ENDS */}
                  {/* MOST LIKED IMAGE POSTS STARTS */}
                  {(loading || (influencerData?.most_liked_images?.length > 0 || influencerData?.most_liked_carousel?.length > 0)) &&
                    <section className='sec-media-posts'>
                      <div className='container custom-container'>
                        <strong className='sec-media-posts__title'>Most Viewed Images</strong>


                        <InsightMediaImageCard influencerData={influencerData && influencerData} loading={loading} />
                      </div>
                    </section>
                  }
                  {props?.UserReducer?.view_chatbot === 'True' &&
                    <ChatBotWidget
                      sendMessage={sendMessage}
                      loading={AILoading}
                      messages={messages}
                    />
                  }
                  {/* MOST LIKED IMAGE POSTS ENDS */}
                </div>
              </div>
            </div>
      )}
        {socialRestrictionPopup.instagram &&
            <SocialConnectRestriction open={socialRestrictionPopup.instagram} data = {ig_data} onClose={handleCloseSocialPopup_IG} continueConnect={handleContinueConnect_IG} />
        }

        {/* SHARE PROFILE Popup */}
        {openSharePopup && (
          <CommonPopUp
            className="modal-medium share-container"
            openModal={openSharePopup}
            modalTitle="Share"
            onClose={handleCloseSharePopup}
          >
            <div className="analytic-share-option d-flex align-items-center mb-3">
              <strong className="analytic-share-option-title">Share via:</strong>
              <div className="analytic-share-option-container">
                <span className="btn btn-outline-primary d-inline-flex react-share-btn">
                  <WhatsappShareButton
                    url={shareURL || ""}
                    className="Demo__some-network__share-button"
                    disabled={!shareURL}
                  >
                    <WhatsappIcon style={{ color: "#25D366" }} />
                    <span className="share-titles">WhatsApp</span>
                  </WhatsappShareButton>
                </span>
                <button
                  onClick={handleCopyShareLink}
                  disabled={shareLoading}
                  className="btn btn-outline-primary d-inline-flex"
                >
                  <MaterialSymbol iconName="link" fontweight="200" />
                  Copy Link
                </button>
              </div>
            </div>
          </CommonPopUp>
        )}

        {/* REFRESH PROFILE Popup */}
        {showRefreshPopup && (
          <CommonPopUp
            className="modal-small refresh-profile-popup"
            openModal={showRefreshPopup}
            modalTitle="Refresh Profile"
            onClose={handleCloseRefreshPopup}
            centered
          >
            <div className="popup-content text-center">
              <p className="mb-3">{refreshPopupMessage}</p>
              <button className="btn btn-primary" onClick={handleCloseRefreshPopup}>
                Okay
              </button>
            </div>
          </CommonPopUp>
        )}
    </Fragment >
  );
};

const mapStateToProps = (state: any) => {
  return {
    UserReducer: state.UserReducer.UserData,
    getSubscriptionDetail: state.Subscription.subscription_detail
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    loading: (data: any) => dispatch(Loading(data)),
    updateUser: (data: any) => dispatch(UserLogin(data)),
  };
};

const connectToRedux = connect(mapStateToProps, mapDispatchToProps)(ProfileInsight);

export { connectToRedux as ProfileInsight };